'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {ViewMode} from '../../../_libs/redux-observable-list/src/enums';
import {Button} from '../../../components/buttons/Button';
import {QuickStatusButton} from '../../../components/buttons/QuickStatusButton';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {ButtonState, isButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {FormResponse} from '../../../form-builder/components/response/FormResponse';
import {RequirementNavigationBar} from '../RequirementNavigationBar';
import {RequirementViewBannerForm} from '../RequirementViewBannerForm';


// Not part of first MTR view sprint. Pending form requirement model and primary content component setup.
export function BaseRequirementViewFormView(props) {
  const requirement = props.requirement;

  return (
    <ProjectLayout
      className={classNames("RequirementViewForm", props.className)}
      title={props.viewTitle}
      showBackButton={true}
      onGoBack={props.onGoBack}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={null}
      headerRightContent={(
        <Fragment>
          <QuickStatusButton
            className="RequirementViewForm__quickButton"
            model={requirement}
            status={get(requirement, 'status')}
            validStatuses={get(requirement, 'validStatuses')}
            disabled={props.isEditingForm}
          />
          <Button
            className="RequirementViewForm__headerButton"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={(
        <RequirementNavigationBar
          collection={props.collection}
        />
      )}
      bannerContent={(
        <RequirementViewBannerForm
          userId={props.userId}
          collection={props.collection}
          requirement={requirement}
          showQuickSubmit={props.showQuickSubmit}
          showQuickApprove={props.showQuickApprove}
          quickMode={props.quickMode}
          isEditingForm={props.isEditingForm}
          updateFormMode={props.updateFormMode}
          isFormDirty={props.isFormDirty}

          onClickEdit={props.onClickEdit}
          onSelectSubmit={props.onSelectSubmit}
          onSelectApprove={props.onSelectApprove}
          onToggleHeaderExpanded={props.onToggleHeaderExpanded}
          onToggleEditingForm={props.onToggleEditingForm}
          onTriggerSaveForm={props.onTriggerSaveForm}

          init={props.init}
        />
      )}

      mode={ViewMode.SUCCESS}
      onLoadMore={noop}
    >
      <FormResponse
        className="RequirementViewForm__formResponse"
        model={get(props.requirement, 'formResponse')}
        isEditing={props.isEditingForm}
        isSaving={props.updateFormMode === ButtonState.WORKING}
        triggerSave$={props.triggerSaveForm$}
        onSave={props.onSaveForm}
        onIsDirtyChange={props.onIsFormDirtyChange}
        useKeyboardPadding={true}
      />
    </ProjectLayout>
  );
}

BaseRequirementViewFormView.propTypes = {
  className: T.string,
  requirement: T.object,
  showQuickSubmit: T.bool,
  showQuickApprove: T.bool,
  quickMode: isButtonState,

  onClickOptions: T.func.isRequired,
  onClickEdit: T.func.isRequired,
  onToggleHeaderExpanded: T.func.isRequired,
  onClickItem: T.func.isRequired,
  onItemContextMenu: T.func.isRequired,
  onIsFormDirtyChange: T.func.isRequired,

  viewTitle: T.string,

  init: T.bool,
};

BaseRequirementViewFormView.defaultProps = {
  init: true,
};

export const RequirementViewFormView = I18nComponent(BaseRequirementViewFormView, [
  {code: 'requirements.views.form.title', prop: 'viewTitle'},
]);



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementViewForm/RequirementViewFormView.js